module.exports = __webpack_public_path__ + "media/components/app-store/static/s6-19020b59ea21aa59dfd2fd3f6d297b48.jpg";